//SHARED FILE : USED ON DETAILS AND PRODUCT LIST AND CART
//ANY CHANGES SHOULD BE TESTED ON ALL PAGES
var favoriteHelper = function(){	
	/*var checkBulkProdsFav = function(){ 		
		if(document.getElementsByClassName('favPrintIcons')[0]){
            		var prodsInBoardsRequest = ajax({
                		method: "POST",
                		url: "/Product/BulkFaveItemsAsync",
            		});
            		prodsInBoardsRequest.then(function (response) {
                		if (response.success == true){
					var favedItems = response.data;
						var favLinkProd = [].slice.call(document.getElementsByClassName("faveLinkProdID"));
						favLinkProd.forEach(function (el) {
							var productID = el.value; 
							if (typeof(favedItems) !== 'undefined' && favedItems && favedItems.includes(parseInt(productID))){
								el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textDkGray");
								el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textRed");
							}else{
								el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textRed");
								el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textDkGray");
							}
						});
                		}else{
					// do nothing in case it had errored out but the icons had been set server side
				}
			});
		}
	};*/
	var favDropdownMenu = (function(){
		var closeAll = function(){
			var favLink = [].slice.call(document.querySelectorAll('.faveLink'));
		   	favLink.forEach(function(heartIcon){
		   		if(heartIcon.getAttribute("aria-expanded") == "true"){	   			
		   			var favDropdown = heartIcon.nextElementSibling;
					close(favDropdown, heartIcon);
		   		}
		   	});
		},
		close = function(favDropdown, favHeart){
			favDropdown.setAttribute("aria-hidden", "true");
			favDropdown.classList.remove("slideDown");				
			setTimeout(function(){
				favDropdown.classList.add("hide");
			}, 100);
			
	    		favHeart.setAttribute("aria-expanded", "false");
	    		favHeart.focus();
	    		
			var addToBoardMsg = [].slice.call(document.getElementsByClassName('addToBoardMsg'));
			addToBoardMsg.forEach(function (msg) {
				msg.parentNode.removeChild(msg);
			});
		},
		closeOnEscape = function(e){
			if ((e.which || e.keyCode) === 27) {
                		closeAll();
            		}
		},
		open = function(e){
			e.preventDefault();
			var heartIcon = e.currentTarget;
			if(document.querySelector(".productListItem")){ // list page item
				closeAll();
			}							
			var boardDropDown = heartIcon.parentNode.getElementsByClassName('ideaBoardList')[0];
			heartIcon.setAttribute("aria-expanded", "true");
	    		boardDropDown.classList.add("slideDown");
	    		boardDropDown.classList.remove("hide");
	    		boardDropDown.setAttribute("aria-hidden", "false");
	    		boardDropDown.getElementsByClassName("cancelBoardList")[0].focus();
	    		
	    		boardDropDown.removeEventListener('keydown', closeOnEscape);
	    		boardDropDown.addEventListener('keydown', closeOnEscape);
		},
		addToExistingBoard = function(e){
			e.preventDefault();
			var boardName = e.currentTarget;
			if(document.getElementsByClassName('addToBoardMsg')[0]){
				document.getElementsByClassName('addToBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('addToBoardMsg')[0]);
			}
			ajaxActions.AddToIdeaBoard(boardName);
		},
		itemEvents = function(){
			if(document.getElementsByClassName("cancel-delete-item")[0]){
				document.getElementsByClassName("cancel-delete-item")[0].addEventListener("click", function(e){
					e.preventDefault();
					var boardMsg = this.parentNode.parentNode;
					boardMsg.parentNode.removeChild(boardMsg);
				});
			}
			if(document.getElementsByClassName("confirm-delete-item")[0]){
				document.getElementsByClassName("confirm-delete-item")[0].addEventListener("click", function(e){
					e.preventDefault();
					var arr = this.getAttribute('href').split('/');
					ajaxActions.DeleteBoardItem(arr[0], arr[1], this);
				});
			}
		};
		return{
			Close: close,
			CloseAll: closeAll,
			Open: open,
			AddToExistingBoard: addToExistingBoard,
			ItemEvents: itemEvents
		};
	})(),	
	
	cartFavorite = (function(){
		var save = function(e){
			e.preventDefault();
			if(document.getElementsByClassName('cancel-new-board')[0]){
				document.getElementsByClassName('cancel-new-board')[0].click();
			}
			if(document.getElementsByClassName('newBoardMsg')[0]){
				document.getElementsByClassName('newBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('newBoardMsg')[0]);
			}
			if (this.classList.contains('registered')) {
				ajaxActions.GetBoardForm();
			} else {
				window.location = "/registration/login";
			}
		},
		validateBoardForm = function(e){
			e.preventDefault();
			var boardName = document.getElementById("boardName");
			boardName.classList.remove("input-validation-error");
			boardName.setAttribute("aria-invalid", "false");
			boardName.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
			
			if(boardName.value == ""){
				boardName.classList.add("input-validation-error");
				boardName.setAttribute("aria-invalid", "true");
				boardName.parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
				boardName.focus();
			}else{
				ajaxActions.CreateBoardWithCart();
			}
		},
		cancel = function(e){
			e.preventDefault();
			document.getElementById('newBoardForm').parentNode.removeChild(document.getElementById('newBoardForm'));
			document.getElementsByClassName('saveAsFavBoard')[0].focus();
		},
		addToBoard = function(e){
			e.preventDefault();
			var el = e.currentTarget;
			if(document.getElementsByClassName('addToBoardMsg')[0]){
				document.getElementsByClassName('addToBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('addToBoardMsg')[0]);
			}
			ajaxActions.AddCartItemsToBoard(el);
		},
		events = function(){			
			document.getElementById('submitNewBoard').addEventListener("click", validateBoardForm);

			var cancelBoardBtns = [].slice.call(document.getElementsByClassName("cancelCartBoard"));
			cancelBoardBtns.forEach(function(cancelCartBtn){
				cancelCartBtn.addEventListener("click", cancel);
			});
			
			document.getElementById('newBoardForm').addEventListener('keydown', function (e) {
	           		if ((e.which || e.keyCode) === 27) { /*esc*/
	                		cancel();
	            		}
	        	});
	        	
	        	//add cart items to existing board	
			var existingBoards = [].slice.call(document.getElementsByClassName('boardListItem'));
			existingBoards.forEach(function(existingBoard){
				existingBoard.addEventListener("click", addToBoard);
			});
		};
		return{
			Save: save,
			Events: events
		};
	})(),
	
	ajaxActions = (function(){
		var checkDetailsPage = function(el){
			var productID = (typeof (prodID) == 'undefined') ? el.querySelectorAll(".faveLinkProdID")[0].value : prodID;
			var data = { productID: productID };
			var listInBoardRequest = ajax({
				method: "POST",
				url: "/Product/IsItemInBoardAsync",
				data: data
			});
			listInBoardRequest.then(function (response) {
				var favItems;
				if (response.success == true){
					favItems = [].slice.call(document.getElementsByClassName('favoriteItem'));
					favItems.forEach(function(heartIcon){
						heartIcon.classList.remove("textDkGray");
						heartIcon.classList.add("textRed");
					});
				}else{
					favItems = [].slice.call(document.getElementsByClassName('favoriteItem'));
					favItems.forEach(function(heartIcon){
						heartIcon.classList.add("textDkGray");
						heartIcon.classList.remove("textRed");
					});
				}
			});
		},
		addToIdeaBoard = function (el) {
			var boardIDNumber = el.parentNode.getElementsByClassName('board-id')[0].value;
			var productID = (typeof (prodID) == 'undefined') ? el.closest('.favPrintIcons').querySelectorAll('.faveLinkProdID')[0].value : prodID;
			if (productID == null) {
				//still not found? try mobile details
				productID = document.getElementById('productid').value;
			}
			var data = { boardID: boardIDNumber, productID: productID };
			el.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
			var addItemBoardRequest = ajax({
				method: "POST",
				url: "/favs/additemtoboard",
				data: data
			});
			addItemBoardRequest.then(function (response, xhr) {
				el.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
				//If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
	        		el.insertAdjacentHTML('afterend', response.message);
	        		if (response.success == "true") {
	            			el.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.remove('textDkGray');
	            			el.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.add('textRed');
	            			el.nextElementSibling.getElementsByTagName("a")[0].focus();
	            			favDropdownMenu.ItemEvents();
	        		}
			});
		},
		deleteBoardItem = function(e, f, g) {
			var boardID = e;
			var boardItemID = f;
			var data = { boardID: boardID, boardItemID: boardItemID };
			g.parentNode.parentNode.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
		  	var deleteBoardItemRequest = ajax({
		  		method: "POST",
		  		url: '/favs/deleteboarditem',
		  		data: data
		  	});
		  	deleteBoardItemRequest.then(function (response, xhr) {
	                	g.parentNode.parentNode.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
	                	if (response.isItemInOtherBoards == "False") {
	              		g.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.remove('textRed');
	              		g.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.add('textDkGray');
	          		}
	          		g.closest('.addToBoardMsg').parentNode.removeChild(g.closest('.addToBoardMsg'));
	            	});
		},
		getBoardForm = function() {
			document.getElementById("loading").classList.remove("hide");
			var boardFormRequest = ajax({
				method: "POST",
				url: '/favs/getcartboardform'
			});
			boardFormRequest.then(function (response, xhr) {
	                    document.getElementById("loading").classList.add("hide");
	                    var wrapper = document.createElement("div");
	                    wrapper.innerHTML = response;
	                    document.getElementById('mainContent').appendChild(wrapper);
	                    
	        		var saveAsFavorite = dialog4i();
	        		saveAsFavorite.init(document.getElementById('newBoardForm'));
	        		saveAsFavorite.open();
	        		document.getElementById('boardName').focus();
	        		cartFavorite.Events();
	              });
		},
		createBoardWithCart = function() {
			var form = document.getElementById('newCartBoard');
		    	var boardName = form.querySelectorAll('#boardName')[0].value;
		    	var isDefaultBoard = form.querySelectorAll('#isDefaultBoard')[0].checked ? true : false;
		    	var note = form.querySelectorAll('#Notes')[0].value;
		    	var cartID = document.getElementById('UserCart_CartID').value;
		    	var data = { Name: boardName, CreatedDate: null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note, CartID: cartID };
		  	
		  	var addNewBoard = ajax({
		  		method: "POST",
		  		url: '/favs/addnewboard',
		  		data: data
		  	});
		  	addNewBoard.then(function (response, xhr) {
		        	if (response.length > 1) {
		          		omniture.LogNewBoardCreation();
		          		//var wrapperDiv = document.createElement("div");
		          		//wrapperDiv.innerHTML = response;
		         		//document.getElementById('newBoardForm').replaceWith(wrapperDiv);	          		
		          		document.querySelector(".cancelCartBoard").click();
		          		document.getElementById("cartLinks").insertAdjacentHTML("afterend", response);
		          		document.getElementsByClassName('newBoardMsg')[0].getElementsByTagName("a")[0].focus();
	        		}
	              });
		},
		addCartItemsToBoard = function(el) {
		    	var boardID = el.parentNode.getElementsByClassName('board-id')[0].value;
		    	var cartID = document.getElementById('UserCart_CartID').value;
		    	var data = { cartID: cartID, boardID: boardID };
		    	
		    	el.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
		  	var addCartItems = ajax({
		  		method: "POST",
		  		url: "/favs/addcartitemstoboard",
		  		data: data
		  	});
		  	addCartItems.then(function (response, xhr) {
	                   	el.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
	                   	el.insertAdjacentHTML('afterend', response.message);
	                   	el.nextElementSibling.getElementsByTagName("a")[0].focus();
			});
		};
		
		return {
			CheckDetailsPage: checkDetailsPage,
			AddToIdeaBoard: addToIdeaBoard,
			DeleteBoardItem: deleteBoardItem,
			GetBoardForm: getBoardForm,
			CreateBoardWithCart: createBoardWithCart,
			AddCartItemsToBoard: addCartItemsToBoard
		};
	})(),
	omniture = (function () {
		var logNewBoardCreation = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
	          		s.linkTrackVars = 'prop26';
	          		s.linkTrackEvents = 'None';
	          		s.prop26 = "Fav Board Creations";//New board, log create event
	          		s.tl(true, 'o', 'Fav Board Creations');
	      		}
	    	};
		var viewProductClick = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
		  		s.linkTrackVars = 'eVar36';
		  		s.linkTrackEvents = 'none';
		 		s.eVar36 = "Fav Boards Conversions";//Product click event variable expires at purchase
		  		s.tl(true, 'o', 'Fav Boards Conversions');
			}
	    	};
	    	return {
	      		ViewProductClick: viewProductClick,
	      		LogNewBoardCreation: logNewBoardCreation
	    	};
	})(),
	
	init = function(){
		if(document.getElementsByClassName('favPrintIcons')[0]){
			var favIcons = [].slice.call(document.getElementsByClassName('favPrintIcons'));
			if(!favIcons[0].classList.contains('mobileList')){ //details page 
				ajaxActions.CheckDetailsPage(favIcons[0]);
			}	
		}
		
		var heartIcons = [].slice.call(document.getElementsByClassName('faveLink'));  //on detail and list
	   	heartIcons.forEach(function(heartIcon){
			heartIcon.addEventListener('click', favDropdownMenu.Open);
		});
		
		if(document.getElementsByClassName('saveAsFavBoard')[0]){ // cart page
			document.getElementsByClassName('saveAsFavBoard')[0].addEventListener('click', cartFavorite.Save);
		}
		
		var viewProductLinks = [].slice.call(document.getElementsByClassName("viewProduct")); // list page
		viewProductLinks.forEach(function(prodLink){
			prodLink.addEventListener("click", function(e){
				e.preventDefault();
				omniture.ViewProductClick();
				window.location = e.currentTarget.href;
			});
		});
		
		var cancelBoards = [].slice.call(document.getElementsByClassName('cancelBoardList')); // list and details page
		cancelBoards.forEach(function(cancelBtn){
			cancelBtn.addEventListener("click", function (e) {
				e.preventDefault();
				var favDropdown = cancelBtn.parentNode.parentNode;
				var favHeart = cancelBtn.parentNode.parentNode.previousElementSibling;
				favDropdownMenu.Close(favDropdown, favHeart);
			});
		});
		
		var boardNames = [].slice.call(document.getElementsByClassName('boardName'));
		boardNames.forEach(function(boardName){
			boardName.addEventListener("click", favDropdownMenu.AddToExistingBoard);
		});
		
		var lastLinks = [].slice.call(document.querySelectorAll(".viewAllFavs"));
		lastLinks.forEach(function(lastLink){
			// trap focus
			lastLink.addEventListener("keydown", function(e){
				if(e.keyCode == 9){
					e.preventDefault();
					e.stopPropagation();
					this.parentNode.parentNode.querySelector(".cancelBoardList").focus();
				}
			});
		});
	};
	
	return {
		init: init
	};
};

(function(){
	var favHelper = new favoriteHelper();
	favHelper.init();
})();